import React from 'react';
import { Button, Card, CardBody, Input, Table } from 'reactstrap';
import { Detail } from './types';

interface ProductDetailsSectionProps {
    details: Detail[];
    onAddDetail: () => void;
    onUpdateDetail: (id: string, field: keyof Detail, value: any) => void;
    onRemoveDetail: (id: string) => void;
}

const ProductDetailsSection: React.FC<ProductDetailsSectionProps> = ({
    details,
    onAddDetail,
    onUpdateDetail,
    onRemoveDetail
}) => {
    const handleInputChange = (id: string, field: keyof Detail) => (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = field === 'quantity' ? parseInt(e.target.value) || 0 : e.target.value;
        onUpdateDetail(id, field, value);
    };

    return (
        <Card className="shadow border-0 overflow-hidden rounded-3">
            <div className="bg-soft-primary p-3 border-bottom border-light d-flex justify-content-between align-items-center">
                <h5 className="card-title mb-0 text-primary fw-semibold d-flex align-items-center">
                    <i className="ri-shopping-cart-2-line me-2 fs-18"></i>
                    Detalles de Productos
                </h5>
                <Button 
                    color="primary" 
                    size="sm" 
                    className="btn-label shadow-sm"
                    onClick={onAddDetail}
                >
                    <i className="ri-add-line label-icon align-middle fs-16 me-2"></i>
                    Añadir Producto
                </Button>
            </div>
            <CardBody className="p-0 bg-white">
                <div className="table-responsive">
                    <Table className="table-nowrap align-middle mb-0 table-hover">
                        <thead className="bg-light text-muted text-uppercase small">
                            <tr>
                                <th className="ps-4" style={{width: '20%'}}>Código Principal</th>
                                <th style={{width: '20%'}}>Código Auxiliar</th>
                                <th style={{width: '15%'}}>Cantidad</th>
                                <th style={{width: '35%'}}>Descripción</th>
                                <th style={{width: '10%'}} className="text-end pe-4">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {details.length === 0 ? (
                                <tr>
                                    <td colSpan={5} className="text-center py-5">
                                        <div className="avatar-sm mx-auto mb-3">
                                            <div className="avatar-title bg-soft-light rounded-circle text-primary fs-24">
                                                <i className="ri-shopping-basket-line"></i>
                                            </div>
                                        </div>
                                        <h5 className="text-muted mb-1">No hay productos agregados</h5>
                                        <p className="text-muted mb-0 small">Haga clic en "Añadir Producto" para comenzar</p>
                                    </td>
                                </tr>
                            ) : (
                                details.map((item, index) => (
                                    <tr key={item.id} className={index % 2 === 0 ? 'bg-white' : 'bg-soft-light bg-opacity-25'}>
                                        <td className="ps-4">
                                            <div className="input-group input-group-sm">
                                                <span className="input-group-text bg-light border-end-0">
                                                    <i className="ri-barcode-line text-muted"></i>
                                                </span>
                                                <Input 
                                                    bsSize="sm" 
                                                    value={item.code} 
                                                    onChange={handleInputChange(item.id, "code")} 
                                                    placeholder="Código Principal"
                                                    className="form-control border-start-0 ps-1"
                                                />
                                            </div>
                                        </td>
                                        <td>
                                            <div className="input-group input-group-sm">
                                                <span className="input-group-text bg-light border-end-0">
                                                    <i className="ri-barcode-box-line text-muted"></i>
                                                </span>
                                                <Input 
                                                    bsSize="sm" 
                                                    value={item.auxCode || ''} 
                                                    onChange={handleInputChange(item.id, "auxCode")} 
                                                    placeholder="Código Auxiliar"
                                                    className="form-control border-start-0 ps-1"
                                                />
                                            </div>
                                        </td>
                                        <td>
                                            <div className="input-group input-group-sm">
                                                <span className="input-group-text bg-light border-end-0">
                                                    <i className="ri-hashtag text-muted"></i>
                                                </span>
                                                <Input 
                                                    bsSize="sm" 
                                                    type="number"
                                                    value={item.quantity} 
                                                    onChange={handleInputChange(item.id, "quantity")} 
                                                    placeholder="Cant."
                                                    className="form-control border-start-0 ps-1"
                                                    style={{width: '80px'}}
                                                />
                                            </div>
                                        </td>
                                        <td>
                                            <div className="input-group input-group-sm">
                                                <span className="input-group-text bg-light border-end-0">
                                                    <i className="ri-file-list-line text-muted"></i>
                                                </span>
                                                <Input 
                                                    bsSize="sm" 
                                                    value={item.description} 
                                                    onChange={handleInputChange(item.id, "description")} 
                                                    placeholder="Descripción del producto"
                                                    className="form-control border-start-0 ps-1"
                                                />
                                            </div>
                                        </td>
                                        <td className="text-end pe-4">
                                            <Button 
                                                color="soft-danger" 
                                                size="sm" 
                                                className="btn-icon shadow-none"
                                                onClick={() => onRemoveDetail(item.id)}
                                                title="Eliminar producto"
                                            >
                                                <i className="ri-delete-bin-line"></i>
                                            </Button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>
                </div>
            </CardBody>
        </Card>
    );
};

export default ProductDetailsSection;
